module.exports = __webpack_public_path__ + "static/media/cart.f5a415b8.svg";